import { Dialog } from "@reach/dialog";
import "@reach/dialog/styles.css";
import classNames from "classnames/bind";
import React, { useContext, useRef } from "react";
import FontAwesome from "react-fontawesome";
import styles from "./Modal.module.scss";
import {
  type ModalBodyProps,
  type ModalFooterProps,
  type ModalHeaderProps,
  type ModalProps,
} from "./types";

const ModalContext = React.createContext<{
  onClose: React.MouseEventHandler;
}>({
  onClose: () => undefined,
});

const cx = classNames.bind(styles);

// REVIEW: this component needs refactoring. Remove Reach UI use and investigate using React ARIA instead
/** @deprecated use Dialog instead */
const Modal = ({
  className = "",
  style,
  size = "medium",
  open,
  onClose,
  disableInitialFocus = false,
  initialFocusRef = undefined,
  children,
  ariaLabel = "Modal",
}: ModalProps) => {
  const dialogRef = useRef(null);

  return (
    <ModalContext.Provider value={{ onClose }}>
      <Dialog
        isOpen={open}
        autoFocus={!disableInitialFocus}
        initialFocusRef={disableInitialFocus ? dialogRef : initialFocusRef}
        onDismiss={onClose}
        className={cx("modal", size && `modal--${size}`, className)}
        style={style}
        aria-label={ariaLabel}
        ref={dialogRef}
      >
        {children}
      </Dialog>
    </ModalContext.Provider>
  );
};

/** @deprecated use Dialog instead */
const Header = ({
  children,
  style,
  className = "",
  ...props
}: ModalHeaderProps) => {
  const { onClose } = useContext(ModalContext);
  return (
    <div
      style={style}
      className={`${styles.header} ${className}`}
      {...props}
    >
      {children}
      <button
        className={styles.closeButton}
        aria-label="close"
        onClick={onClose}
      >
        <FontAwesome name="times fa fa-fw" />
      </button>
    </div>
  );
};

/** @deprecated use Dialog instead */
const Body = ({
  children,
  style,
  className = "",
  ...props
}: ModalBodyProps) => {
  return (
    <div
      style={style}
      className={`${styles.content} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

/** @deprecated use Dialog instead */
const Footer = ({
  children,
  style,
  className = "",
  ...props
}: ModalFooterProps) => {
  return (
    <div
      style={style}
      className={`${styles.footer} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;
